// Code generated by rwo-uam-manager v1.0.12

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
// ReSharper disable InconsistentNaming
const __AuthorizationResources = {
    AuthorizationService: {
        AuditReport: {
            All: "9e236af2-fc69-40ca-abeb-0f2c2597ceed"
        }
    },
    CompanyDataService: {
        Company: {
            All: "bd34c4f6-7424-4c38-9352-bd24c8c98f03"
        },
        CompanySetting: {
            All: "0e38c9f3-4862-4a73-ad30-d3b7c43ec505"
        }
    },
    ContentDeliveryService: {
        RoomMetadata: {
            All: "36a468c5-a46a-44f8-929b-d16616b6de4e"
        },
        Content: {
            All: "ccc1759b-2a90-436b-8d43-1714462b9401"
        },
        Avatar: {
            All: "9833878c-a486-4f41-9e87-15ae29ab1d46"
        },
        ContentMetadata: {
            All: "d57122ed-7e69-4030-b151-22e5ed49e435"
        },
        ReleaseChannel: {
            All: "4d24b6f9-3fa3-46c9-905d-4f36e4365bbb"
        },
        Release: {
            All: "1c37bdf5-ea06-48d2-b6cb-bcaaff167158"
        },
        File: {
            All: "8575f10c-d9a3-4afd-828c-e4fc588fb228"
        },
        Update: {
            All: "b2bf983f-9c4a-4487-af3c-4409f4983e65"
        },
        Installer: {
            All: "a3d10a43-29df-4f2a-b4cf-c8051681bfdb"
        },
        UserContentMetadata: {
            All: "bea8fa69-8b9f-4112-9503-a9c463a8eb3e"
        },
        Spotlight: {
            All: "5097b5a8-b55e-4d12-a863-4f98f7768566"
        },
        Tag: {
            All: "c792b2ca-4cd5-479f-8d01-47b43f66aef7"
        },
        ContentType: {
            All: "55dd2187-b98f-4777-8673-c39e45d6bdcf"
        }
    },
    GeolocationService: {
        Location: {
            All: "08c481ff-d47f-45c6-8e3b-b6d00f87bc96"
        }
    },
    Global: {
        Group: {
            All: "355f0c94-9890-4a40-8dac-746d67f75106",
            Company_Administrator: "f004e7a7-9b61-40b7-aebe-45a1b416c9ad",
            Administrator: "d686c86e-43f1-49cc-b9b1-c8458abfc37e"
        }
    },
    LearningManagementService: {
        EventTemplate: {
            All: "b1c2d3e4-5678-90ab-cdef-1234567890ab"
        },
        Implementation: {
            All: "a1b2c3d4-5678-90ab-cdef-1234567890ab"
        },
        Plugin: {
            All: "733bedad-740d-4cf9-ac29-a3935d19bf98"
        },
        DefaultTemplate: {
            All: "f67c5060-a9db-4a7e-a6bd-b2730c648fe4"
        },
        LearningEvent: {
            All: "f1e2d3c4-5678-90ab-cdef-1234567890ab"
        },
        LearningProgress: {
            All: "3572f9b3-8be0-4cd9-b7b1-b1bb40f12018"
        },
        TinCan: {
            All: "17b59754-ba89-4693-88fb-ebfb57d65b5d"
        }
    },
    LicensingService: {
        License: {
            All: "1d865bdb-ef83-43ac-8410-a9569020d66c"
        },
        LicenseAllocation: {
            All: "4901ea20-8f3b-4ce4-bf17-99693650d357"
        }
    },
    MDMService: {
        MdmContent: {
            All: "c1b68e1a-3de3-48d6-92fb-9b04b92adde3"
        },
        CompanyMdm: {
            All: "0c0291c8-d07d-4627-9056-49f34ec7b8a6"
        },
        PublishedContent: {
            All: "792923a6-18f8-4a57-8574-b02891c149b0"
        },
        MqfbBuild: {
            All: "bfa30c42-e033-4936-9b37-51e6678f3a3d"
        }
    },
    MailService: {
        Template: {
            All: "37479b87-d99b-4560-9dc7-6f014010c5fc"
        },
        CompanyTemplate: {
            All: "2a179e7d-4b94-4ccc-8224-e69bf24b40fe"
        },
        Footer: {
            All: "4a9b79d0-b589-4e51-b0a8-f677c24a226d"
        },
        Email: {
            All: "21b7781c-9f49-4320-bda6-d356ce55729c"
        }
    },
    MediaStreamingManagementService: {
        MediaRoom: {
            All: "631dd9b6-c579-4fbf-9f52-4c5e1082b4e3"
        },
        AccessToken: {
            All: "311c93e5-1875-49f3-ba0f-5aaebdf1b991"
        }
    },
    SessionManagementService: {
        MultiplayerSessionInvitation: {
            All: "27a00364-fe8b-43ad-aa98-47eb84209143"
        },
        MultiplayerSession: {
            All: "a7672bed-fe1a-4e63-a0a6-5fd6f91bed0e"
        },
        DeviceSession: {
            All: "dff391c3-7a35-48c5-ba8b-c90aaafccddd"
        }
    },
    TelemetryManagementService: {
        Event: {
            All: "dbe9a5e6-a518-481d-893e-020a17fdc96b"
        },
        Contract: {
            All: "b69720f7-6fbb-4fbd-b2a0-8814b6897858"
        },
        Field: {
            All: "72eaad7e-17d1-409c-8daf-0b1cdcee07cf"
        },
        PseudonymizedField: {
            All: "4a41e42a-37e4-4267-9f30-b1844b8a34ff"
        }
    },
    UserGeneratedContentService: {
        UserFile: {
            All: "c4474fff-68f8-4b3b-850c-c1d3f3e807be"
        },
        JsonFile: {
            All: "08d6a827-1631-4ff4-b8bd-92e64c3f2b80"
        },
        Replay: {
            All: "7b21738f-db11-418e-8bdb-7aca34865fea"
        }
    },
    UserManagementService: {
        User: {
            All: "57a8891d-d71c-4dfd-9763-e1e01dcc660e"
        },
        UserSetting: {
            All: "03896057-d1ff-45a3-a71b-8ab864ce4871"
        },
        Permission: {
            All: "3e492e51-ddc8-44ce-9234-be68ccc2204d"
        },
        UserAvatarConfiguration: {
            All: "81ea942e-acd9-4dd6-bad5-b4bba233f5f3"
        },
        UserAvatarPermission: {
            All: "a72e05dd-1043-4473-bda1-d862a750e7b7"
        },
        UserGroup: {
            All: "e3900e36-f09e-4c0d-9a3d-9e72423598f9"
        },
        ContactRequest: {
            All: "dd864935-458c-44ba-98fa-3637336a72ee"
        },
        Invitation: {
            All: "384dc938-ecee-49fc-90f7-c5aad2c0815f"
        }
    }
};

export { __AuthorizationResources as AuthorizationResources };

export namespace Authorization {
    export const AuthorizationResources = __AuthorizationResources;
}
